---
title: "Risiken und Nebenwirkungen von AI"
date: "2026-01-02"
excerpt: "Eine kurze Anekdote über die Beschleunigung durch AI bei der Produktentwicklung und die Risiken durch unvollständige Marktrecherche. Wie Expertier1 in 4 Tagen entstand."
metaTitle: "Risiken und Nebenwirkungen von AI: Beschleuniger und Risiko zugleich"
metaDescription: "Wie AI die Entwicklung von Expertier1 beschleunigte, aber bei der Marktrecherche wichtige Konkurrenten übersah. Eine Lektion in Demut und Geschwindigkeit."
language: "de"
slug: "risiken-und-nebenwirkungen-von-ai"
author: "Kevin Rassner"
authorUrl: "https://rassner-dev.org"
canonicalUrl: "https://rassner-dev.org/blog/risiken-und-nebenwirkungen-von-ai"
publishedOn: "rassner-dev.org"
tags: ["AI", "Startup", "Freelancer", "Marktrecherche", "Expertier1"]
linkedinUrl: "https://www.linkedin.com/posts/kevin-rassner_risiken-und-nebenwirkungen-von-ai-eine-activity-7412512731431620608-X4-A?utm_source=share&utm_medium=member_desktop&rcm=ACoAABOVTMUBYXTIxIvCDnvaQZ6lrRF9KkXF3WM"
isLinkedInPost: true
---

Eine ehemalige Kollegin und Freundin Dr. Angela Steinbach hatte eine Geschäftsidee, die sehr gut klang: Die Abfindungswelle in der deutschen Automobilindustrie startet eine Entwicklung, die wir vielleicht aufgreifen können: Firmen entlassen u.a. viele Experten und es ist abzusehen, dass viele von denen anschließend durch diese oder andere Firmen wieder benötigt werden - jedoch unter flexibleren Konditionen.

Wie bereits vor vielen Jahren in den USA wird der Freelancer-Sektor hier in Deutschland einen Aufschwung erleben. Viele Experten sind aber verunsichert durch diesen Karrierepfad: Anmeldung eines Gewerbes, Vertriebsarbeit, Rechnungsstellung?

Hier wollten wir ansetzen: Zielgruppe von OEM und Tier1-Experten. Vollautomatisierte Unterstützung bei Anmeldung, Betrieb und Abrechnung der Tätigkeiten, sodass die Experten, die bisher durch ihre Konzerne so betreut waren, nun mit niedrigen Hürden in die Selbstständigkeit finden.

Das war vor 5 Tagen. Also Perplexity angeworfen, 15 Seiten Marktrecherche und erkannt, das eine Lücke existiert, die noch kein Konkurrent schließt.

import ToolTooltip from '@/components/ToolTooltip';

Vier Tage später stand der App-MVP (tatsächlich 3: eine für Consultants, eine für Firmen, eine zur Administration für den Betreiber): <ToolTooltip toolId="expertier1"><a href="/tools#expertier1">Expertier1</a></ToolTooltip>.

[AI](/blog/ai-organisationskultur-agent-forschung) also als wahnsinniger Beschleuniger.

Dann gestern: Angela schreibt mir, dass es eine Firma gibt, die genau das macht. Perplexity hatte diese nicht auf dem Schirm (Malt, ihr braucht bessere AIO! :D).

AI also auch als Risiko :D.

Ich habe mich also mal bei der Konkurrenz angemeldet und schaue mal, ob es dort noch Lücken gibt die es zu schließen gilt ;). Ich bin nicht traurig drüber, ich habe wieder mehr über das Entwickeln gelernt und bin noch bereiter für die nächste Runde!

[Original Post auf LinkedIn](https://www.linkedin.com/posts/kevin-rassner_risiken-und-nebenwirkungen-von-ai-eine-activity-7412512731431620608-X4-A?utm_source=share&utm_medium=member_desktop&rcm=ACoAABOVTMUBYXTIxIvCDnvaQZ6lrRF9KkXF3WM)
